import React, { ReactNode, createContext, useContext, useState } from 'react';

interface AppSettingsContextProps {
  collapsed: boolean;
  setCollapsed: (value: boolean) => void;
}

const AppSettingsContext = createContext<AppSettingsContextProps | undefined>(undefined);

export function AppSettingsProvider({ children }: { children: ReactNode }) {
  const [collapsed, setCollapsed] = useState(false);

  const contextValue = React.useMemo(() => ({ collapsed, setCollapsed }), [collapsed]);

  return <AppSettingsContext.Provider value={contextValue}>{children}</AppSettingsContext.Provider>;
}

export const useAppSettings = () => {
  const context = useContext(AppSettingsContext);
  if (!context) {
    throw new Error('useAppSettings must be used within an AppSettingsProvider');
  }
  return context;
};
